import { defaultTheme } from '@dataplace.ai/ui-components/themes/defaultTheme'

export const daypartTranslationMap = {
  morning: 'placeme.analyse.overview.dayparts_traffic.morning',
  lunch: 'placeme.analyse.overview.dayparts_traffic.lunch',
  afternoon: 'placeme.analyse.overview.dayparts_traffic.afternoon',
  evening: 'placeme.analyse.overview.dayparts_traffic.evening',
  night: 'placeme.analyse.overview.dayparts_traffic.night',
} as const

export const daypartTimeRanges = {
  morning: '6:00-11:00',
  lunch: '11:00-15:00',
  afternoon: '15:00-18:00',
  evening: '18:00-22:00',
  night: '22:00-6:00',
} as const

export const backgroundColors = [
  defaultTheme.palette.product.location.main,
  defaultTheme.palette.indigo,
  defaultTheme.palette.product.location.medium,
  defaultTheme.palette.product.location.light,
  defaultTheme.palette.softLavender,
]
